import Showcase from '@/components/Showcase';
import CodeFeatureCard from '@/components/CodeFeatureCard';

import queries from '@/utils/demo-queries';
import mutations from '@/utils/demo-mutations';

const examples = [...queries, ...mutations];

export default function APIShowcase() {
  return (
    <Showcase items={examples} Component={CodeFeatureCard} layout="vertical" />
  );
}
